import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import initBootstrapComponents from '../../utils/bootstrap';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Modal from 'react-bootstrap/Modal';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import { useBasket } from '../../context/BasketContext';
import axios from 'axios';
import OrderDetails from '../../components/OrderDetails/OrderDetails';

const BasketConfirmation = () => {
    const navigate = useNavigate();
    const { basket } = useBasket();
    const [formData, setFormData] = useState({
        title: '',
        firstName: '',
        lastName: '',
        email: '',
        telephone: '',
        addressLine1: '',
        addressLine2: '',
        houseNumber: '',
        postcode: '',
        isExistingCustomer: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        // Initialize Bootstrap components when component mounts
        initBootstrapComponents();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        // e.preventDefault();
        // setLoading(true);

        // try {
        //     const formDataObj = new FormData();
        //     // Add each slot ID individually to formData
        //     basket.slots.forEach(slot => {
        //         formDataObj.append('slots[]', parseInt(slot.id));
        //     });
        //     formDataObj.append('customer[email]', formData.email);
        //     formDataObj.append('customer[first_name]', `${formData.name}`);
        //     const ambassadorId = localStorage.getItem('ambassador_id');
        //     formDataObj.append('ambassador_id', ambassadorId);
        //     formDataObj.append('key', '7678356c642c91a255471d162205e0f3');

        //     if(basket.vehicle) {
        //         formDataObj.append('vehicle_id', basket.vehicle.id);
        //     }

        //     formDataObj.append('customer[marketing_consent]', formData.marketingConsent ? 1 : 0);

        //     const token = localStorage.getItem('ambassador_token');
        //     // store all the form data in local storage
        //     localStorage.setItem('formData', JSON.stringify(formData));

        //     // Log the token to check its value
        //     console.log('Token being sent:' + token);

        //     const resp = await axios.post('https://apistaging.motabilityschemelive.co.uk/api/events/bookings/book', formDataObj, {
        //         headers: {
        //             'Accept': 'application/json',
        //             'Authorization': `Bearer ${token}`,
        //             'X-Requested-With': 'XMLHttpRequest',
        //             'Content-Type': 'multipart/form-data'
        //         },
        //         withCredentials: true // Move withCredentials out of headers where it belongs
        //     });

        //     console.log('Response:', resp);

        //     // store the response in local storage
        //     localStorage.setItem('bookingResponse', JSON.stringify(resp));
            
        //     // Navigate to confirmation page
        //     navigate('/checkout');
        // } catch (error) {
        //     console.error('Booking error:', error);
        //     console.error('Full error object:', error.response); // Log full error response
        //     setError(error.response?.data?.message || 'An error occurred while creating your booking');
        // } finally {
        //     setLoading(false);
        // }

    // Store customer details in local storage

        const customerDetails = {
            email: formData.email,
            title: formData.title,
            firstName: formData.firstName,
            lastName: formData.lastName,
            telephone: formData.telephone,
            addressLine1: formData.addressLine1,
            addressLine2: formData.addressLine2,
            houseNumber: formData.houseNumber,
            postcode: formData.postcode,
            isExistingCustomer: formData.isExistingCustomer,
            marketingConsent: formData.marketing_consent
        };
        localStorage.setItem('customerDetails', JSON.stringify(customerDetails));

        navigate('/checkout');

    };

    const handleLookupAddress = () => {
        // Implement address lookup functionality
        console.log('Looking up address for:', formData.postcode);
    };

    // Format date to match the design
    const formatDate = (date) => {
        return new Date(date).toLocaleDateString('en-GB', {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
    };

    // Format time to match the design
    const formatTime = (dateTimeString) => {
        return new Date(dateTimeString).toLocaleTimeString('en-GB', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        }).toLowerCase();
    };

    // Group slots by date
    const groupedSlots = basket?.slots?.reduce((acc, slot) => {
        const date = formatDate(slot.date);
        if (!acc[date]) {
            acc[date] = [];
        }
        acc[date].push(slot);
        return acc;
    }, {});

    const isBasketEmpty = !basket.slots || basket.slots.length === 0;

    return (
        <div className="d-flex flex-column justify-content-between min-vh-100" id="body-container">
            <Header />

            <main>
                <section className="bg-motability-mid-black-5 py-32 pt-lg-96 pb-lg-148" id="book-vehicle">
                    <div className="container">
                        <h1 className="text-primary mb-4 mb-lg-5">
                            Customer details
                        </h1>

                        <div className="row row-gap-4 row-gap-lg-0 gx-xxl-5">
                            <div className="col-lg-6">
                                <div className="bg-motability-white border border-motability-mid-black-25 rounded-4 p-4 p-lg-32 pt-lg-28">
                                    <h5 className="text-primary fw-semibold mb-4 mb-lg-32">
                                        Please enter your details below
                                    </h5>

                                    <form onSubmit={handleSubmit} className="custom" id="book-a-test-drive-form">
                                        <fieldset>
                                            <div className="row gx-xxl-32">
                                                <div className="form-group col-lg-5 col-xl-4 mb-3">
                                                    <label htmlFor="book-a-test-drive-title" className="small ms-1 mb-1">
                                                        Title
                                                    </label>
                                                    <select 
                                                        name="title" 
                                                        id="book-a-test-drive-title" 
                                                        className="form-select f-input-lg blue-select-dropdown border-motability-mid-black-40 shadow-motability-mid-black-12-inset"
                                                        value={formData.title}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="" disabled>-Select-</option>
                                                        <option value="mr">Mr</option>
                                                        <option value="mrs">Mrs</option>
                                                        <option value="miss">Miss</option>
                                                        <option value="ms">Ms</option>
                                                        <option value="dr">Dr</option>
                                                    </select>
                                                </div>

                                                <div className="form-group col-12 mb-3">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <label htmlFor="book-a-test-drive-first-name" className="small ms-1 mb-1">
                                                                First name *
                                                            </label>
                                                            <input 
                                                                name="firstName" 
                                                                id="book-a-test-drive-first-name" 
                                                                type="text" 
                                                                className="form-control f-input-lg border-motability-mid-black-40 shadow-motability-mid-black-12-inset"
                                                                required
                                                                value={formData.firstName}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label htmlFor="book-a-test-drive-last-name" className="small ms-1 mb-1">
                                                                Last name *
                                                            </label>
                                                            <input 
                                                                name="lastName" 
                                                                id="book-a-test-drive-last-name" 
                                                                type="text" 
                                                                className="form-control f-input-lg border-motability-mid-black-40 shadow-motability-mid-black-12-inset"
                                                                required
                                                                value={formData.lastName}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="form-group mb-3">
                                                    <label htmlFor="book-a-test-drive-email-address" className="small ms-1 mb-1">
                                                        Email address *
                                                    </label>
                                                    <input 
                                                        name="email" 
                                                        id="book-a-test-drive-email-address" 
                                                        type="email" 
                                                        className="form-control f-input-lg border-motability-mid-black-40 shadow-motability-mid-black-12-inset"
                                                        required
                                                        value={formData.email}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>

                                                <div className="form-group mb-3">
                                                    <label htmlFor="book-a-test-drive-telephone-number" className="small ms-1 mb-1">
                                                        Telephone number*
                                                    </label>
                                                    <input 
                                                        name="telephone" 
                                                        id="book-a-test-drive-telephone-number" 
                                                        type="tel" 
                                                        className="form-control f-input-lg border-motability-mid-black-40 shadow-motability-mid-black-12-inset"
                                                        required
                                                        value={formData.telephone}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>

                                                <div className="form-group mb-3">
                                                    <label htmlFor="book-a-test-drive-house-name-or-number" className="small ms-1 mb-1">
                                                        House name or number
                                                    </label>
                                                    <input 
                                                        name="houseNumber" 
                                                        id="book-a-test-drive-house-name-or-number" 
                                                        type="text" 
                                                        className="form-control f-input-lg border-motability-mid-black-40 shadow-motability-mid-black-12-inset"
                                                        value={formData.houseNumber}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>

                                                <div className="form-group mb-3">
                                                    <label htmlFor="book-a-test-drive-address-line-1" className="small ms-1 mb-1">
                                                        Address line 1
                                                    </label>
                                                    <input 
                                                        name="addressLine1" 
                                                        id="book-a-test-drive-address-line-1" 
                                                        type="text" 
                                                        className="form-control f-input-lg border-motability-mid-black-40 shadow-motability-mid-black-12-inset"
                                                        value={formData.addressLine1}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>

                                                <div className="form-group mb-3">
                                                    <label htmlFor="book-a-test-drive-address-line-2" className="small ms-1 mb-1">
                                                        Address line 2
                                                    </label>
                                                    <input 
                                                        name="addressLine2" 
                                                        id="book-a-test-drive-address-line-2" 
                                                        type="text" 
                                                        className="form-control f-input-lg border-motability-mid-black-40 shadow-motability-mid-black-12-inset"
                                                        value={formData.addressLine2}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>

                                                <div className="form-group col-5 col-md-4 mb-4 mb-lg-32">
                                                    <label htmlFor="book-a-test-drive-postcode" className="small ms-1 mb-1">
                                                        Postcode *
                                                    </label>
                                                    <input 
                                                        name="postcode" 
                                                        id="book-a-test-drive-postcode" 
                                                        type="text" 
                                                        className="form-control f-input-lg border-motability-mid-black-40 shadow-motability-mid-black-12-inset"
                                                        required
                                                        value={formData.postcode}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
{/* 
                                                <div className="form-group mb-4 mb-lg-40">
                                                    <button 
                                                        type="button" 
                                                        id="book-a-test-drive-look-up-address" 
                                                        className="btn btn-outline-primary fw-normal px-29"
                                                        onClick={handleLookupAddress}
                                                    >
                                                        Look up address
                                                    </button>
                                                </div> */}

                                                <div className="form-group mb-4 mb-lg-40">
                                                    <p className="text-primary fw-semibold">
                                                        Are you an existing Motability Scheme customer?
                                                    </p>

                                                    <div className="d-flex align-items-center gap-5">
                                                        <div className="form-check d-flex align-items-center mb-0">
                                                            <input 
                                                                name="isExistingCustomer" 
                                                                id="book-a-test-drive-is-existing-customer" 
                                                                type="radio" 
                                                                className="form-check-input cursor-pointer mt-0"
                                                                value="yes"
                                                                checked={formData.isExistingCustomer === 'yes'}
                                                                onChange={handleInputChange}
                                                                required
                                                            />
                                                            <label htmlFor="book-a-test-drive-is-existing-customer" className="form-check-label cursor-pointer ps-12">
                                                                Yes
                                                            </label>
                                                        </div>

                                                        <div className="form-check d-flex align-items-center mb-0">
                                                            <input 
                                                                name="isExistingCustomer" 
                                                                id="book-a-test-drive-is-not-existing-customer" 
                                                                type="radio" 
                                                                className="form-check-input cursor-pointer mt-0"
                                                                value="no"
                                                                checked={formData.isExistingCustomer === 'no'}
                                                                onChange={handleInputChange}
                                                                required
                                                            />
                                                            <label htmlFor="book-a-test-drive-is-not-existing-customer" className="form-check-label cursor-pointer ps-12">
                                                                No
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="form-group mb-4 mb-lg-40">
                                                    <p className="text-primary fw-semibold">
                                                        Are you happy for the Motability Scheme to send you marketing data?
                                                    </p>

                                                    <div className="d-flex align-items-center gap-5">
                                                        <div className="form-check d-flex align-items-center mb-0">
                                                            <input 
                                                                name="marketing_consent" 
                                                                id="marketing_consent_yes" 
                                                                type="radio" 
                                                                className="form-check-input cursor-pointer mt-0"
                                                                value="yes"
                                                                checked={formData.marketing_consent === 'yes'}
                                                                onChange={handleInputChange}
                                                                required
                                                            />
                                                            <label htmlFor="marketing_consent_yes" className="form-check-label cursor-pointer ps-12">
                                                                Yes
                                                            </label>
                                                        </div>

                                                        <div className="form-check d-flex align-items-center mb-0">
                                                            <input 
                                                                name="marketing_consent" 
                                                                id="marketing_consent_no" 
                                                                type="radio" 
                                                                className="form-check-input cursor-pointer mt-0"
                                                                value="no"
                                                                checked={formData.marketing_consent === 'no'}
                                                                onChange={handleInputChange}
                                                                required
                                                            />
                                                            <label htmlFor="marketing_consent_no" className="form-check-label cursor-pointer ps-12">
                                                                No
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div>
                                                    <button type="submit" className="btn btn-primary px-29" disabled={isBasketEmpty}>
                                                        Book your test drive
                                                    </button>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </form>
                                </div>
                            </div>

                            <OrderDetails basket={basket} groupedSlots={groupedSlots} formatTime={formatTime} />
                        </div>

                        <div className="d-flex flex-column align-items-start mt-4 mt-lg-64">
                            <button 
                                onClick={() => navigate(-1)} 
                                className="btn btn-link p-0 text-decoration-none"
                            >
                                ‹ <span className="text-decoration-underline">Back to test drive booking</span>
                            </button>
                        </div>
                    </div>
                </section>
            </main>

            <Footer />
        </div>
    );
};

export default BasketConfirmation;
